<template>
  <LessonContent :title="lesson.title" :order="lesson.order">

     <form-wizard class="mt-3 lesson-wizard"  color="black" errorColor="rgba(var(--vs-danger), 1)" backButtonText="<" title="" subtitle="" nextButtonText=">" :finishButtonText="buttonTitle">

      <tab-content title="">
        <LessonTabContent>
              <span class="font-black text-6xl">Tiniest goal</span>

             <img class="mx-auto p-4 lesson-intro-image" src="@/assets/images/academy/academy_popup_3.svg"/>

        </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>
           <p>
             <p>I will lose weight</p>
             <p>I will build a house</p>
             <p>I will have a successful business</p>
             <p>I will have abs</p>
             <p>I will win an Olympics</p>
             <p>I will make a world a better place</p>
             <p class="mt-2 font-italic">I will...</p>
           </p>

       </LessonTabContent>
      </tab-content>



      <tab-content title="">
        <LessonTabContent>
        <div class="w-1/2 mx-auto mb-4">
                <img src="@/assets/images/academy/aca_11.png"/>
            </div>

       </LessonTabContent>
      </tab-content>




      <tab-content title="">
        <LessonTabContent>

        <div class="w-1/2 mx-auto mb-4">
                <img src="@/assets/images/academy/aca_12.png"/>
            </div>
          <p>
             In this session, you will turn <span class="font-italic">I will...</span>  into reality.
           </p>

       </LessonTabContent>
      </tab-content>

         <tab-content title="">
        <LessonTabContent>
          <p>
             Once you have a dream, then comes the fun part where you need to ask yourself: 
           </p>

           <p class="text-4xl mt-2">
             What am I willing to do for it?
           </p>
       </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>
           <p>
              We tend to feel like dreams don't have a deadline, no wonder, they are just <span class="font-semibold">too distant and hard to visualize.</span>
           </p>
       </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>
           <p>
             But without a deadline, there is no urgency. 
           </p>

           <p>
             Without urgency, there <span class="font-semibold">won't be a real beginning or end.</span>
           </p>
       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>

        <div class="w-1/2 mx-auto my-4">
                <img src="@/assets/images/academy/aca_13.png"/>
            </div>


       </LessonTabContent>
      </tab-content>


     <tab-content title="">
        <LessonTabContent>
         <p>
             This is why the next step is the creation of a <span class="font-semibold">smaller goal</span> that is within your reach and <span class="font-semibold">achievable in a short period</span> of time.
           </p>
       </LessonTabContent>
      </tab-content>

     <tab-content title="">
        <LessonTabContent>
         <p>
            If you are not experienced in goal-setting (even if you are), you should start with the <span class="font-semibold">tiniest goal</span> you can imagine. 
          </p>

       </LessonTabContent>
      </tab-content>


     <tab-content title="">
        <LessonTabContent>

          <p class="text-3xl">
            The big journey begins with small steps.
          </p>

       </LessonTabContent>
      </tab-content>

<!--         <tab-content title="">
        <LessonTabContent>
          <p>Setting smaller goals has many advantages, but one of them is the gamification of your life. </p>

       </LessonTabContent>
      </tab-content> -->


        <tab-content title="">
        <LessonTabContent>

          <p>
           Happiness may only be <span class="font-semibold">found on the way up the hill</span>, not in the fleeting sense of satisfaction that awaits you at the top.
          </p>
       </LessonTabContent>
      </tab-content>


        <tab-content title="">
        <LessonTabContent>

          <p>
            Start where you are,
          </p>
          <p>
            use what you have,
          </p>
          <p>
            do what you can.
          </p>
       </LessonTabContent>
      </tab-content>

        <tab-content title="" :beforeChange="saveAndExit">
        <LessonTabContent>
            <div class="w-1/2 mx-auto mb-4">
                <img src="@/assets/images/academy/aca_14.png"/>
            </div>

          <p><span class="">Create a tiniest goal toward your dream</span></p>

          <div class="mt-2">
            <vs-button color="#5222D0" size="large" @click="redirectToActionBoard">create a goal</vs-button>
          </div>
       </LessonTabContent>
      </tab-content>

        </div>

    </form-wizard>
  </LessonContent>

</template>

<script>
import LessonContent from './LessonContent'
import LessonTabContent from './LessonTabContent'
import { FormWizard, TabContent } from 'vue-form-wizard'
import LessonMixin from '../../Generic/LessonMixin'

export default {
  components: {
    LessonContent,
    LessonTabContent,
    TabContent,
    FormWizard
  },
  props: ['lesson'],
  mixins: [LessonMixin],
  data () {
    return {}
  },
  computed: {
    openFinishButton () { return 'complete' },
    completedFinishButton () { return 'close' },
  },
  methods: {
    redirectToActionBoard () {
      const routeData = this.$router.resolve({ name: 'planner', query: { initWithGoalSidebarOpen: 'true'  }})
      window.open(routeData.href, '_blank')
    }
  },
}
</script>
